export const enum SnCameraProtocol {
  HTTP = 'http',
  HTTPS = 'https',
  RTSP = 'rtsp',
  RTMP = 'rtmp',
  RTSPS = 'rtsps',
  UDP = 'udp',
}
